import { connect } from 'react-redux'
import { FOLDER as folderTitleType } from 'constants/conversation_list_types'
import {
  selectAccountCanSeePinnedSearches,
  selectShowExperimentalLabelUi,
} from 'selectors/app/selectAccountPreferences'
import { selectCurrentFolderName } from 'ducks/folders/selectors/items'
import { selectCurrentQueryId } from 'ducks/searches/selectors'
import TitleBarView from 'components/ConversationList/Header/TitleBar'
import Count from './Count'
import SortMenu from './SortMenu'
import BulkActionBar from './BulkActionBar'

const select = state => ({
  canSeePinnedSearches: selectAccountCanSeePinnedSearches(state),
  isFreeFormSearch: false,
  isSearchPinnable: false,
  isSelectionMode: false,
  pinnedSearch: null,
  searchIsFolderSearch: true,
  title: selectCurrentFolderName(state),
  queryId: selectCurrentQueryId(state),
  titleType: folderTitleType,
  isExperimentalLabelUiEnabled: selectShowExperimentalLabelUi(state),
  CountComponent: Count,
  SortMenuComponent: SortMenu,
  BulkActionBarComponent: BulkActionBar,
})

export default connect(select)(TitleBarView)
